<template>
  <div>
    <!-- 数据库 -->
    <div class="databases">
      <div>
        <Button
          type="primary"
          @click="modal = true"
          v-hasPermission="['aiMonitor:applicationConfiguration:add_database']"
          >添加数据库</Button
        >
      </div>
    </div>
    <Modal
      v-model="modal"
      title="添加数据库"
      width="1100px;"
      :loading="modalLoading"
      ok-text="添加"
      :mask-closable="false"
    >
      <Form
        :model="databasesForm"
        :label-width="100"
        ref="databasesForm"
        :rules="ruleValidate"
      >
        <!-- 搜索 -->
        <Row :gutter="16">
          <Col span="4">
            <!-- 云平台 -->
            <FormItem
              label="云平台"
              prop="accountTypeSearchKey"
              :label-width="60"
            >
              <Select
                v-model="databasesForm.accountTypeSearchKey"
                filterable
                @on-change="
                  searchAccountType(databasesForm.accountTypeSearchKey)
                "
                :transfer="true"
              >
                <Option
                  :value="item.id"
                  v-for="item in accountTypeList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <!-- 账户 -->
            <FormItem label="账户" prop="account" :label-width="50">
              <Select
                filterable
                v-model="databasesForm.account"
                @on-change="changeAccount(databasesForm.account)"
                :transfer="true"
              >
                <Option
                  :value="item.id"
                  v-for="(item, index) in accountList"
                  v-bind:key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <!-- 存储区域 -->
            <FormItem label="存储区域" prop="region" :label-width="80">
              <Select
                filterable
                @on-change="changebackupRegion(databasesForm.region)"
                v-model="databasesForm.region"
                :transfer="true"
              >
                <Option
                  :value="item.name"
                  v-for="item in regionList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6" v-show="isDatabaseEngines">
            <!-- 数据库引擎 -->
            <FormItem
              label="数据库引擎"
              prop="databaseEngines"
              :label-width="80"
            >
              <Select
                filterable
                v-model="databasesForm.databaseEngines"
                @on-change="
                  changeDatabaseEngines(databasesForm.databaseEngines)
                "
                :transfer="true"
              >
                <Option
                  :value="item.name"
                  v-for="item in databaseEnginesList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Button
            type="primary"
            style="float: right"
            v-show="isShowSearch"
            @click="searchDatabaseInput()"
            >{{ $t("alarms.common.search") }}
          </Button>
        </Row>
        <Table
          :no-data-text="$t('common.noData')"
          ref="selection"
          :columns="columns"
          :loading="loading"
          :data="queryAccountDatabasesData"
          :height="400"
          @on-selection-change="getSelection"
        ></Table>
      </Form>
      <div slot="footer">
        <Button @click="handleReset('databasesForm')">取消</Button>
        <Button
          type="primary"
          @click="handleSubmit('databasesForm')"
          :loading="addloading"
          :disabled="isDisable"
          >添加
        </Button>
      </div>
    </Modal>
    <table-databases ref="tableDatabasesChild"></table-databases>
  </div>
</template>

<script>
import { getCookie } from "../../../utils/cookieUtil.js";
import TableDatabases from "../application_configuration/TableDatabases";

var tableDatabases = TableDatabases;
export default {
  name: "AddDatabases",
  components: {
    TableDatabases
  },
  data() {
    return {
      databasesForm: {
        account: "",
        region: "",
        accountTypeSearchKey: "",
        databaseEngines: ""
      },
      accountTypeList: [],
      databaseEnginesList: [],
      accountList: [],
      regionList: [],
      selection: [],
      state: [
        "creating",
        "available",
        "stopping",
        "stopped",
        "shutting down",
        "terminated",
        "running",
        "incompatible-network"
      ],
      modal: false,
      modalLoading: true,
      loading: false,
      addloading: false,
      isDisable: true,
      isShowSearch: false,
      isDatabaseEngines: false,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("alarms.database.name"),
          key: "name"
        },
        {
          title: this.$t("alarms.database.databaseId"),
          key: "databaseId"
        },
        {
          title: this.$t("alarms.database.engine"),
          key: "engine"
        },
        {
          title: this.$t("alarms.database.instanceType"),
          key: "type"
        },
        {
          title: this.$t("alarms.database.state"),
          key: "stateName"
        },
        {
          title: this.$t("alarms.database.region"),
          key: "region"
        }
      ],
      ruleValidate: {
        accountTypeSearchKey: [
          {
            required: true,
            message: "请选择云平台",
            trigger: "change",
            type: "number"
          }
        ],
        databaseEngines: [
          { required: false, message: "请选择数据库引擎", trigger: "change" }
        ],
        account: [
          {
            required: true,
            message: "请选择账户名称",
            trigger: "change",
            type: "number"
          }
        ],
        region: [
          { required: true, message: "请选择存储区域", trigger: "change" }
        ]
      },
      queryAccountDatabasesData: [],
      newQueryAccountDatabasesDataList: []
    };
  },
  methods: {
    // 父组件调用子组件table内的方法
    queryDatabasesByApplicationId() {
      this.$refs.tableDatabasesChild.queryDatabasesByApplicationId();
    },
    //查询云平台
    getAccountType: function() {
      this.$api.account
        .queryCloudPlatformsMSP("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountTypeList = res.data;
        });
    },
    //选择云平台
    searchAccountType: function() {
      if (this.databasesForm.accountTypeSearchKey == 2) {
        this.isDatabaseEngines = true;
      } else {
        this.isDatabaseEngines = false;
      }
      this.databasesForm.region = "";
      this.databasesForm.databaseEngines = "";
      // 清空表格
      this.queryAccountDatabasesData = [];
      this.isShowSearch = true;
      this.selectAccountByCloudPlatform();
    },
    // 查询数据库引擎
    queryDatabaseEngines: function() {
      this.$api.rds
        .queryDatabaseEngines("userName", getCookie(global.cookieName))
        .then(res => {
          this.databaseEnginesList = res.data;
        });
    },
    //查询账号
    selectAccountByCloudPlatform: function() {
      if (this.databasesForm.accountTypeSearchKey == undefined) {
        return;
      }
      this.$api.account
        .selectAccountByCloudPlatform(
          "type",
          this.databasesForm.accountTypeSearchKey
        )
        .then(res => {
          this.accountList = res.data;
        });
    },
    // 切换账户
    changeAccount: function() {
      if (
        this.databasesForm.account == "" ||
        this.databasesForm.account == null
      ) {
        return;
      }
      this.databasesForm.databaseEngines = "";
      this.databasesForm.region = "";
      this.isShowSearch = true;
      this.$api.account
        .queryAccountRegions("accountId", this.databasesForm.account)
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 切换存储区域
    changebackupRegion: function() {
      this.databasesForm.databaseEngines = "";
      this.queryAccountDatabasesData = [];
      this.isShowSearch = true;
    },
    // 数据库引擎
    changeDatabaseEngines: function() {
      this.queryAccountDatabasesData = [];
      this.isShowSearch = true;
    },
    getState: function(stateStr) {
      for (var i = 0; i < this.state.length; i++) {
        if (stateStr == this.state[i]) {
          return i;
        }
      }
      return -1;
    },
    // 当前选择checkbox
    getSelection: function(selection) {
      this.selection = selection;
      // 清空数组
      this.newQueryAccountDatabasesDataList = [];
      for (var i = 0; i < this.selection.length; i++) {
        // 状态
        var TableQueryDatabaseDataCopy = new Object();
        TableQueryDatabaseDataCopy.databaseId = this.selection[i].databaseId;
        TableQueryDatabaseDataCopy.name = this.selection[i].name;
        TableQueryDatabaseDataCopy.engine = this.selection[i].engine;
        TableQueryDatabaseDataCopy.state = this.selection[i].state;
        TableQueryDatabaseDataCopy.region = this.selection[i].region;
        TableQueryDatabaseDataCopy.type = this.selection[i].type;
        TableQueryDatabaseDataCopy.awsZone = this.selection[i].awsZone;
        TableQueryDatabaseDataCopy.accountId = this.selection[i].accountId;
        TableQueryDatabaseDataCopy.allocatedStorage = this.selection[
          i
        ].allocatedStorage;
        TableQueryDatabaseDataCopy.iops = this.selection[i].iops;
        this.newQueryAccountDatabasesDataList.push(TableQueryDatabaseDataCopy);
      }

      // 选了数据 可以点击下一步
      if (this.newQueryAccountDatabasesDataList.length == 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    // 点击查询
    searchDatabaseInput: function() {
      if (
        this.databasesForm.account == "" ||
        this.databasesForm.account == null ||
        this.databasesForm.region == "" ||
        this.databasesForm.region == null
      ) {
        return;
      }
      //数据库列表
      this.$api.groupDatabaseRelation
        .queryDatabaseByGroupMSP({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          region: this.databasesForm.region,
          accountId: this.databasesForm.account
        })
        .then(res => {
          this.queryAccountDatabasesData = res.data;
        });
    },
    // 添加
    handleSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 增加
          this.addloading = true;
          this.$api.applicationDatabaseRelation
            .createApplicationDatabaseRelation({
              applicationId: this.$route.query.id,
              alertRuleName: this.$route.query.alertRuleName,
              databaseDTOS: this.newQueryAccountDatabasesDataList
            })
            .then(res => {
              setTimeout(() => {
                tableDatabases.methods.showAllDatabase();
                this.$refs[name].resetFields();
                this.modalLoading = false;
                this.$nextTick(() => {
                  this.modalLoading = true;
                });
                this.$Message.success("添加成功");
                this.queryAccountDatabasesData = [];
                this.newQueryAccountDatabasesDataList = [];
                this.modal = false;
                this.addloading = false;
                this.isDisable = true;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    // 取消
    handleReset: function(name) {
      this.isDisable = true;
      this.modal = false;
      this.queryAccountDatabasesData = [];
      this.newQueryAccountDatabasesDataList = [];
      this.$refs[name].resetFields();
    }
  }
};
</script>

<style scoped>
.databases {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/AddDatabases.vue